/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCopyGroup} from '../api'

export const useMutationCreateCopyGroup = createReactQueryMutationHook('createCopyGroup', createCopyGroup)
